// extracted by mini-css-extract-plugin
export var iconContainer = "_ft-0";
export var metricCardsContainer = "_ft-1";